<template>
  <b-card>
    <b-row>
      <b-col sm="12"
             md="10"
             lg="10"
      />
      <b-col sm="12"
             md="2"
             lg="2"
      >
        <b-button variant="primary"
                  size="sm"
                  style="display: block; margin: auto; margin-bottom: .5em;"
                  @click="formCrear()"
        >
          <i class="fa fa-plus"></i> Nuevo
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <!-- TABLA DE TOXICIDADES Y ECOTOXICIDADES -->
      <b-table responsive
               small
               thead-class="table-active"
               :items="toxicidades"
               :fields="columnas"
      >
        <template v-slot:cell(via_ingreso)="row">
          {{ row.item.via_ingreso }}
        </template>
        <template v-slot:cell(componente)="row">
          {{ row.item.componente }}
        </template>
        <template v-slot:cell(animal)="row">
          {{ row.item.animal }}
        </template>
        <template v-slot:cell(marcador)="row">
          {{ row.item.marcador }}
        </template>
        <template v-slot:cell(valor)="row">
          {{ row.item.valor_txt }}
        </template>
        <template v-if="!disabledActions" v-slot:cell(action)="row">
          <el-tooltip
            content="Editar Componente"
            placement="top"
            effect="light"
          >
            <b-button
              size="sm"
              class="mr-1 mt-1"
              variant="primary"
              @click.prevent="editar(row.item)"
            ><i class="el-icon-edit"></i
            ></b-button>
          </el-tooltip>
          <el-tooltip
            content="Eliminar Componente"
            placement="top"
            effect="light"
          >
            <b-button
              size="sm"
              class="mr-1 mt-1"
              variant="danger"
              @click.prevent="eliminarToxicidad(row.item)"
            ><i class="el-icon-delete"></i
            ></b-button>
          </el-tooltip>
        </template>
      </b-table>
      <b-modal id="form-valores-exposicion"
               v-model="form_toxicidades"
               :title="(selectedToxicidad.accion === 'crear' ? 'Crear' : 'Editar') + ' ' + tipo_toxicidad"
               size="lg"
      >
        <ModalFormToxicidad />
        <template #modal-footer="{ cancel }">
          <b-button size="sm" variant="primary" @click="guardar()">
            Guardar
          </b-button>
          <b-button size="sm" variant="danger" @click="cancel()">
            Cancelar
          </b-button>
        </template>
      </b-modal>
    </b-row>
  </b-card>
</template>

<script>
import Swal from "sweetalert2";
import {mapActions, mapMutations, mapState} from "vuex";
import ModalFormToxicidad from "./ModalFormToxicidad";

export default {
  name: "ModalToxicidad",
  components: {
    ModalFormToxicidad,
  },
  data() {
    return {
      disabledActions: false,
      form_toxicidades: false,
    }
  },
  async created() {
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      this.setIdFdsProducto(this.$route.params.id_fds_producto);
    }
  },
  methods: {
    formCrear() {
      this.resetSelectedToxicidad();
      this.form_toxicidades = true;
    },
    async guardar() {
      if (this.selectedToxicidad.accion === 'crear') {
        await this.crearToxicidad();
      } else if (this.selectedToxicidad.accion === 'editar') {
        await this.actualizarToxicidad();
      }
      this.form_toxicidades = false;
    },
    editar(item) {
      this.resetSelectedToxicidad();
      let itemEditar = {
        accion: 'editar',
        id: item.id,
        id_empresa: item.id_empresa,
        id_fds_producto: item.id_fds_producto,
        id_via_ingreso: item.id_via_ingreso,
        componente: item.componente,
        id_animal: item.id_animal,
        id_marcador: item.id_marcador,
        valor_rango: item.valor_rango,
        id_simbolo: item.id_simbolo,
        valor: item.valor,
        id_um_valor: item.id_um_valor,
        id_simbolo_hasta: item.id_simbolo_hasta,
        valor_hasta: item.valor_hasta,
      };
      this.setSelectedToxicidad(itemEditar);
      this.form_toxicidades = true;
    },
    eliminarToxicidad(item) {
      let confirm = false;
      Swal.fire({
        text: "¿Desea eliminar el componente?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#097b83',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.borrarToxicidad(item);
          await this.getToxicidad();
        }
      });
    },
    ...mapMutations('fds_productos', [
      'setIdEmpresaFdsProducto',
      'setIdFdsProducto',
      'resetSelectedToxicidad',
      'setSelectedToxicidad',
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getToxicidad',
      'crearToxicidad',
      'actualizarToxicidad',
      'borrarToxicidad',
    ])
  },
  computed: {
    columnas() {
      return [
        {
          key: "via_ingreso",
          label: "Vía de ingreso",
          thStyle: {
            "min-width": "60px !important",
            width: "60px !important",
          },
        },
        {
          key: "componente",
          label: "Componente",
          thStyle: {
            "min-width": "100px !important",
            width: "100px !important",
          },
        },
        {
          key: "animal",
          label: this.tipo_toxicidad === 'toxicidad' ? 'Animal' : 'Especie',
          thStyle: {
            "min-width": "80px !important",
            width: "80px !important",
          },
        },
        {
          key: "marcador",
          label: "Marcador",
          thStyle: {
            "min-width": "60px !important",
            width: "60px !important",
          },
        },
        {
          key: "valor",
          label: "Valor",
          thStyle: {
            "min-width": "100px !important",
            width: "100px !important",
          },
        },
        {
          key: "action",
          label: "",
          thStyle: {
            "min-width": "80px !important",
            width: "80px !important",
          },
        },
      ];
    },
    ...mapState('fds_productos', [
      'selectedToxicidad',
      'tipo_toxicidad',
      'id_empresa',
      'id_fds_producto',
      'toxicidades',
    ])
  }
}
</script>

<style scoped>

</style>
